import React from "react";
import moment from "moment";
import swal from 'sweetalert';

import Server from "../../services/Server";
import getFileSize from "../../services/getFileSize";

import { Player } from 'video-react';
import "../../../node_modules/video-react/dist/video-react.css";

import completeWithZero from "../../services/completeWithZero";

export default class Recording extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            isLoading: true,
            isDeleting: false,
            records: []
        };

        this.getRecording = this.getRecording.bind(this);
        this.onDeleteVideo = this.onDeleteVideo.bind(this);
    }
    componentDidMount(){
        this._mounted = true;
        this.getRecording();
    }
    getRecording(){
        try {
            const 
                streamId = this.props.event.live_stream.id,
                serverId = this.props.event.videoServer,
                {id = false} = this.props.event;

            if (this._mounted){
                Server.events.getRecording(serverId, streamId, id)
                .then((res)=>{
                    if (res.data.data.length > 0){
                        const arr = [];
                        let videoIndex = 0;
                        const videos = res.data.data;

                        const _process = ()=>{
                            if (videoIndex === videos.length){
                                this.setState({ isLoading: false, records: arr });
                            } else{
                                const video = videos[videoIndex];
                                if (video.duration === 0) {
                                    const theVideo = document.createElement('video');
                                    theVideo.preload = "metadata";

                                    theVideo.addEventListener('loadedmetadata', function () {
                                        if (!isNaN(theVideo.duration)){
                                            video.duration = theVideo.duration * 1000;
                                            arr.push(video);
                                        }
                                        videoIndex++;
                                        _process();
                                    });

                                    theVideo.addEventListener('error', function () {
                                        videoIndex++;
                                        _process();
                                    });

                                    theVideo.src = video.download_url;

                                } else{
                                    arr.push(video);
                                    videoIndex++;
                                    _process();
                                }
                            }
                        }

                        _process();
                        
                    } else{
                        this.setState({
                            isLoading: false,
                            records : [],
                            hasError: true,
                            errorMessage: "Aún no hay grabaciones asociadas a este evento..."
                        });
                    }
                })
                .catch((error)=>{
                    this.setState({ isLoading: false, hasError : true }, ()=>{
                        if (error.response){
                            if (error.response.status === 500){
                                this.setState({ 
                                    isLoading: false,
                                    hasError: true, 
                                    errorMessage: "Hubo un error y la grabación no será cargada..."
                                });
                            } else{
                                this.setState({
                                    isLoading: false,
                                    hasError: true,
                                    errorMessage: "Hubo un error en el cargue, por favor intenta actualizar la página o revisa más tarde..."
                                });    
                            }
                        } else{
                            this.setState({ 
                                isLoading: false,
                                hasError: true, 
                                errorMessage: "Hubo un error en el cargue, por favor intenta actualizar la página o revisa más tarde..." 
                            });
                        }
                    });
                });
            }
        } catch (error) {
            this.setState({ isLoading: false, hasError : true, errorMessage : "No fue posible conectar con el Stream, por favor pasa primero por la zona de configuración y si todo está bien intentalo nuevamente"});
        }
    }
    componentWillUnmount(){
        this._mounted = false;
    }
    onDeleteVideo(video){
        const self = this;
        swal({
            title: "",
            text: `¿Estas seguro que quieres eliminar este video? Este cambio será irreversible.`,
            icon: "warning",
            buttons: true,
            dangerMode: true
        })
        .then((will) => {
            if (will){
                self.setState({ isDeleting: true });
                Server.events.deleteRecording(video.serverId, video.eventId, video.file_name, (video.id || ""))
                .then((response)=>{
                    self.setState({isDeleting : false}, ()=>{
                        swal("La grabación ha sido borrada");
                        self.getRecording();
                    });
                })
                .catch(()=>{
                    self.setState({ isDeleting: false });
                })
            }
        });
    }
    render(){
        const { isLoading, isDeleting, hasError, errorMessage} = this.state;
        if (isLoading){
            return(
                <div className="cntEventLoading"><img src={`${process.env.PUBLIC_URL}/assets/images/loading3.gif`} alt="loading" /></div>
            );
        }
        if (hasError){
            return (
                <div className="alert alert-danger mg-t-30 tx-center">
                    <span>{errorMessage}</span>
                </div>
            );
        }
        
        return(
            <React.Fragment>
            {
                this.state.records.map((record, index)=>{
                const { created_at = 0, download_url = "", duration = 0, file_name = "", 
                    file_size = 0, state = "", updated_at = 0 } = record;
                
                
                const
                    _duration = duration/1000,
                    hours = Math.floor(_duration / 3600),
                    minutes = Math.floor((_duration - (hours * 3600)) / 60),
                    seconds = Math.floor(_duration - (hours * 3600) - (minutes * 60));
                
                    return (
                        <div className="row row-sm row-xl mg-t-20" key={index}>
                            <div className="col-sm-6 row-eq-height">
                                <div className="card card-dashboard-twentyone">
                                    <div className="row no-gutters">
                                        <div className="card-body">
                                            <h6 className="az-content-label record-title">
                                                <span>Grabación {completeWithZero((index + 1), 3)}</span>
                                                <button className="btn btn-outline-danger" disabled={isDeleting} onClick={() => { this.onDeleteVideo(record) }}><i className={"fas fa-" + (isDeleting ? 'spinner fa-spin' : "trash")}/> Eliminar</button>
                                            </h6>
                                            <div className="table-responsive">
                                                <table className="table table-hover mg-b-0">
                                                    <tbody>
                                                        <tr>
                                                            <td>Creado en</td>
                                                            <td>{moment.utc(created_at).local().format("MMM DD [de] YYYY, hh:mm a")}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Duración</td>
                                                            <td>
                                                                {(hours > 0 ? `${hours} hora${(hours === 1 ? '' : 's')}, ` : "")}
                                                                {(minutes > 0 ? `${minutes} minuto${(minutes === 1 ? '' : 's')} y ` : "")}
                                                                {(seconds > 0 ? `${seconds} segundos` : '--')}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Tamaño</td>
                                                            <td>{getFileSize(file_size)}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Última edición</td>
                                                            <td>{moment.utc(updated_at).local().format("MMM DD [de] YYYY, hh:mm a")}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Estado</td>
                                                            <td>{state}</td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={2}>
                                                                <a href={download_url} target="_blank" rel="noopener noreferrer" download={file_name} className="btn btn-outline-indigo btn-block">Descargar</a>
                                                            </td>
                                                        </tr>
                                                        
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-6 row-eq-height">
                                <div className="card card-dashboard-twentyone">
                                    <div className="row no-gutters">
                                        <div className="card-body">
                                            <Player
                                                playsInline
                                                poster="//streaming.com.co/images/estatica.jpg"
                                                src={download_url}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    );
                }, this)
            }
            </React.Fragment>
        )


    }
}